import { api } from '../services/api';

  
// Updated function with more robust error handling
export const pollResearchStatus = async (userID, researchID, statusAttribute, maxAttempts = 100, pollInterval = 5000) => {
  let attempts = 0;
  let errorCount = 0; // Track consecutive error statuses
  const maxErrorCount = 3; // Only consider it a real error after this many consecutive ERROR statuses

  while (attempts < maxAttempts) {
    try {      

      const research = await api.getPreviousResearch(userID, researchID);
      console.log("inside pollResearchStatus, research is", research);
      
      const status = research?.[statusAttribute];

      console.log(`Polling research status: ${status} (attempt ${attempts + 1}/${maxAttempts})`);
      
      if (research && status === 'COMPLETED') {
        return research;
      } else if (research && status === 'ERROR') {
        // Instead of immediately failing, increment error count
        errorCount++;
        console.log(`Received ERROR status (count: ${errorCount}/${maxErrorCount})`);
        
        if (errorCount >= maxErrorCount) {
          // Only throw an error if we've seen multiple consecutive ERROR statuses
          throw new Error('Failed to generate responses after multiple attempts');
        }
      } else {
        // Reset error count if status is not ERROR
        errorCount = 0;
      }

      
      
      // Wait before trying again
      await new Promise(resolve => setTimeout(resolve, pollInterval));
      attempts++;
    } catch (error) {
      // console.error('Error polling research status:', error);
      
      // Don't immediately throw the error unless it's a connection/request error
      if (!error.message.includes('Failed to generate responses')) {
        throw error;
      }
      
      // For generation errors, continue polling
      await new Promise(resolve => setTimeout(resolve, pollInterval));
      attempts++;
    }
  }
  
  throw new Error('Timeout waiting for generation to complete');
};

export function createTopic(data = {}) {
  return {
    userID: data.userID || '',
    researchID: data.researchID || '',
    description: data.description || '',
    surveyDescription: data.surveyDescription || '',
    title: data.title || '',
    surveyQuestions: data.surveyQuestions !== undefined ? data.surveyQuestions : null,
    selectedPersonas: data.selectedPersonas || [],
    personaFilters: data.personaFilters !== undefined ? data.personaFilters : null,
    surveyResponses: data.surveyResponses !== undefined ? data.surveyResponses : null,
    surveyContext: data.surveyContext || '',
    lastGenerationState: data.lastGenerationState !== undefined ? data.lastGenerationState : null,
    surveyStatus: data.surveyStatus !== undefined ? data.surveyStatus : null,
    responsesStatus: data.responsesStatus !== undefined ? data.responsesStatus : null,
    personasStatus: data.personasStatus !== undefined ? data.personasStatus : null,
    lastModified: data.lastModified !== undefined ? data.lastModified :  Math.floor(Date.now() / 1000),
    generatedPersonaFilters: data.generatedPersonaFilters !== undefined ? data.generatedPersonaFilters : null,
    importedPersonas: data.importedPersonas || false,
    importedPersonasFile: data.importedPersonasFile || '',
    researchType: data.researchType || ''
  };
}

export function mapServerResearchToLocal(research) {
  /**
   * questionsObject is the response from the server, like:
   * {
   *   q1: { prompt: '...', kind: 'multiple-choice', vocab: ['Yes','No'], ... },
   *   q2: { prompt: '...', kind: 'open-ended', max_length: 200, ... },
   * }
   * So let's turn that into an array of question objects with
   * questionID, questionText, questionType, responseOptions, etc.
   */


  let surveyQuestions = [];
  if (research?.survey?.questions) {
  
    const questionsObject = research.survey.questions;
    const order = research.survey.order;

    const questionIDs = order || Object.keys(questionsObject);

    surveyQuestions = questionIDs.map((questionID) => {
      const questionData = questionsObject[questionID];
      const isMultipleChoice = questionData.kind === 'multiple-choice';
      const isOpenList = questionData.kind === 'open-list';

      let selectMin;
      let selectMax;

      if (isMultipleChoice) {
        // If min/max exist, use them; otherwise default
        selectMin = typeof questionData.min !== 'undefined' ? questionData.min : 1;
        selectMax = typeof questionData.max !== 'undefined' ? questionData.max : questionData.vocab.length;
      }

      if (isOpenList) {
        selectMin = typeof questionData.min !== 'undefined' ? questionData.min : 1;
        selectMax = typeof questionData.max !== 'undefined' ? questionData.max : 5;
      }

      return {
        questionID,
        questionText: questionData.prompt,
        questionType: questionData.kind,
        responseOptions: isMultipleChoice ? questionData.vocab : [],
        maxLength: questionData.kind === 'open-ended' ? questionData.max_length : undefined,
        selectMin,
        selectMax,

        // If you also track fixed percentages, you can handle them here
        hasFixedPercentages: questionData.hasFixedPercentages || false,
        responsePercentages: questionData.responsePercentages || [],
      };
    });
  }
  return {
    userID: research.userID,
    researchID: research.researchID,
    description: research.description,
    title: research.title,
    lastModified: research.lastModified,
    surveyQuestions,
    surveyDescription: research.survey.description,
    surveyStatus: research.surveyStatus,
    surveyContext: typeof research.survey.survey_context === 'string' ? research.survey.survey_context : '',
    personasStatus: research.personasStatus,
    responsesStatus: research.responsesStatus,
    importedPersonas: research.importedPersonas,
    researchType: research.researchType,
  }
}


  // Helper function to format raw API response data into the array structure you need.
  export function mapServerResponsesToLocal(apiData, researchID) {
    // apiData is expected to have the shape:
    // { personaID1: { questionID1: responseText, questionID2: responseText, ... },
    //   personaID2: { questionID1: responseText, questionID2: responseText, ... }, ... }
    if (apiData === null) {
      return null;
    }
    return Object.entries(apiData).flatMap(([personaID, questionMap]) =>
      Object.entries(questionMap).map(([questionID, response]) => ({
        personaID,
        questionID,
        response,
        researchID,
      }))
    );
  }

  function notEmpty(value) {
    // Check for undefined or null
    if (value == null) return false;

    // Check for empty string
    if (typeof value === 'string' && value.trim() === '') return false;
    
    // Check for empty array
    if (Array.isArray(value) && value.length === 0) return false;
    
    // Check for empty object (but not arrays, dates, etc.)
    if (
      typeof value === 'object' && 
      !Array.isArray(value) && 
      !(value instanceof Date) &&
      Object.keys(value).length === 0
    ) return false;
    
    // Value is not empty
    return true;
  }

  export function getProgress(userData) {
    console.log("userData in getProgress is", userData);
    console.log("notempty of selectedPersonas is", notEmpty(userData.selectedPersonas));

    if (userData.surveyStatus === 'NOT_STARTED') {
      return 0;
    }

    if (userData.personasStatus === 'NOT_STARTED') {
      return 1;
    }

    if (userData.responsesStatus === 'NOT_STARTED') {
      return 2;
    }


    if (userData.responsesStatus === 'COMPLETED') {
      return 4;
    }

    const startedSurvey = userData.surveyStatus === 'COMPLETED'
     || userData.surveyStatus === 'PENDING' 
     || userData.surveyStatus === 'ERROR'
     || userData.surveyStatus === 'PROMPT_CHANGED'
     || notEmpty(userData.surveyQuestions);

     const startedPersonas = userData.personasStatus === 'COMPLETED'
      || userData.personasStatus === 'PENDING'
      || userData.personasStatus === 'ERROR'
      || notEmpty(userData.selectedPersonas);

     const startedResponses = userData.responsesStatus === 'COMPLETED'
      || userData.responsesStatus === 'PENDING'
      || userData.responsesStatus === 'ERROR'
      || userData.responsesStatus === 'SURVEY_CHANGED'
      || notEmpty(userData.surveyResponses);

      let progress = 0;

      if (startedSurvey) {
        progress = 1;
      }

      if (startedPersonas && startedSurvey) {
        progress = 2;
      }

      if (startedResponses && startedPersonas && startedSurvey) {
        progress = notEmpty(userData.selectedPersonas) ? 3 : 2;
      }

      console.log("progress in getProgress is", progress);

      return progress;
  }


export function isPending(userData, setWarningMessage, setOpenWarningSnackbar) {
  console.log("userData in isPending is", userData);
        // Check if responses are pending
        if (userData.responsesStatus === 'PENDING') {
          setWarningMessage('Responses are currently being generated, please wait until completed.');
          setOpenWarningSnackbar(true);
          return true;
        }
        if (userData.personasStatus === 'PENDING') {
          setWarningMessage('Personas are currently being generated, please wait until completed.');
          setOpenWarningSnackbar(true);
          return true;
        }
        if (userData.surveyStatus === 'PENDING') {
          setWarningMessage('Survey questions are currently being generated, please wait until completed.');
          setOpenWarningSnackbar(true);
          return true;
        }
        return false;
      }


export function serverDataToTopics(data) {
    // 1. Convert researches that came from the server
    const baseTopics = data.researches.map(mapServerResearchToLocal);

    // 2. Merge personas / responses into every topic
    const fullTopics = baseTopics.map((topic) => {
      /* ---------- PERSONAS ---------- */
      const personaBlock = data.personas.find(
        (p) => p.researchID === topic.researchID
      );
      const selectedPersonas = personaBlock?.personas || [];
      const personaFilters   = personaBlock?.filters  || [];
      const importedPersonasFile     = personaBlock?.fileName || null;
      const importedPersonas = personaBlock?.importedPersonas || false;

      /* ---------- RESPONSES ---------- */
      const responseBlock = data.responses.find(
        (r) => r.researchID === topic.researchID
      );
      const surveyResponses = responseBlock
        ? mapServerResponsesToLocal(
            responseBlock.responses || null,
            topic.researchID
          )
        : null;

      /* ---------- return combined topic ---------- */
      return {
        ...topic,
        selectedPersonas,
        personaFilters,
        importedPersonasFile,
        importedPersonas,
        surveyResponses,
      };
    });

    return fullTopics;
}